"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderReact = void 0;
var _react = _interopRequireDefault(require("react"));
var _client = require("react-dom/client");
var _server = require("react-dom/server");
var _hypernova = _interopRequireWildcard(require("hypernova"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var renderReact = function renderReact(name, component) {
  return (0, _hypernova["default"])({
    server: function server() {
      return function (props) {
        var contents = (0, _server.renderToString)( /*#__PURE__*/_react["default"].createElement(component, props));
        return (0, _hypernova.serialize)(name, contents, props);
      };
    },
    client: function client() {
      var payloads = (0, _hypernova.load)(name);
      if (payloads) {
        payloads.forEach(function (payload) {
          var node = payload.node,
            data = payload.data;
          var element = /*#__PURE__*/_react["default"].createElement(component, data);
          if (_client.hydrateRoot) {
            (0, _client.hydrateRoot)(node, element);
          } else {
            (0, _client.createRoot)(node).render(element);
          }
        });
      }
      return component;
    }
  });
};
exports.renderReact = renderReact;